import AjaxInvitationService from './ajax-invitation-service'

class CountriesService extends AjaxInvitationService {

  getList(code) {
    const headers = this.getInvitationHeader(code)
    return this.makeGetRequest('/by-invitation/countries', null, headers)
  }
}

const _instance = new CountriesService()
export default _instance